import { newSize, newVector, Size } from '@lessonup/pins-shared';
import React from 'react';
import { DEFAULT_POLYGON_POINTS } from '../shapePinComponent.utils';

export interface PolygonShapeProps {
  size: Size;
  strokeWidth: number;
  points?: number;
}

export const PolygonShape: React.FC<PolygonShapeProps> = ({ size, strokeWidth, points = DEFAULT_POLYGON_POINTS }) => {
  const correctedSize = newSize(size.width - strokeWidth, size.height - strokeWidth);
  const center = newVector(size.width / 2, size.height / 2);
  const startAngle = -Math.PI / 2; // This equals -90 degrees which points straight up in SVG coordinates
  const radii = newVector(correctedSize.width / 2, correctedSize.height / 2);

  const pointsArray = Array.from({ length: points }, (_, i) => {
    const angle = startAngle + (i * 2 * Math.PI) / points;
    // Calculate the point position based on the angle and radius
    const x = center.x + radii.x * Math.cos(angle);
    const y = center.y + radii.y * Math.sin(angle);

    return `${x},${y}`;
  });

  return <polygon points={pointsArray.join(' ')} />;
};
